import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

const page = 'viewErrorPage';
export function ViewErrorPage() {
  const navigate = useNavigate();
  const handleClick = (event) => {
    //Todo
    event.preventDefault();
    navigate('/verify-email', { replace: true });
  };

  return (
    <div className="view-error-page">
      <div className="content">
        <div className="center aligned custom-icon">
          <img className="ui centered medium image custom-image" src="unlink.png" alt="unlink" />
        </div>
      </div>
      <div className="custom-header mark">
        <FormattedMessage id={`${page}.codeExpiry`} defaultMessage="Unfortunately, this code has expired" />
      </div>
      <div className="description">
        <p>
          <FormattedMessage
            id={`${page}.requestNewCodeInfo`}
            defaultMessage="This security code is no longer available for use. However, you can request a new one which will be sent to your email"
          />
        </p>
      </div>
      <div className="ui row">
        <button className="submit-button submit-success-button" onClick={handleClick}>
          <FormattedMessage id={`${page}.requestNewCode`} defaultMessage="Request new security code" />
        </button>
      </div>
    </div>
  );
}
